import { render, staticRenderFns } from "./VrstaPrometaBase.vue?vue&type=template&id=8ac6bcc8&scoped=true&"
import script from "./VrstaPrometaBase.vue?vue&type=script&lang=js&"
export * from "./VrstaPrometaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac6bcc8",
  null
  
)

export default component.exports